/**
 * Created by nicom on 7/29/2017.
 */

import React, { Component } from "react";
import { Input, isInvalid } from "./Inputs";
import "../../css/Hours.css";

class ButtonsInRow extends Component {
  constructor(props) {
    super(props);
    this.renderButtons = this.renderButtons.bind(this);
  }

  render() {
    return this.renderButtons();
  }

  renderButtons() {
    const { saveDisable, saveClicked, cancelClicked, editable } = this.props;

    return !editable ? (
      <div className="ButtonsInRow buttonsInRowHour">
        <span className="edit" onClick={this.props.editModeChange} />
        <span className="delete" onClick={this.props.open} />
      </div>
    ) : (
      <div className="buttonsInRowHour v-x-buttons">
        <span
          disabled={
            saveDisable.some(isInvalid) ||
            !saveDisable.includes(Input.Change)
          }
          onClick={saveClicked}
          className="save-button"
        />
        <span onClick={cancelClicked} className="cancel-button" />
      </div>
    );
  }
}
export default ButtonsInRow;
